<template>
    <div>
        <template v-if="!item[itemShowKey] && activeName !== ''">
            <el-button class="isPrimary" type="text" style="padding-top: 2px;"
                @click="openAssignEdit">
                <BaseIcon name="edit" class="fs-xl" />
            </el-button>
        </template>
    </div>
</template> 

<script>
export default {
    name: 'HelperIcon',
    components: {},
    mixins: [],
    props: {
        itemShowKey: {
            type: String,
            require: true,
            default: ''
        },
        item: {
            type: Object,
            require: true,
            default: () => {}
        },
        activeName: {
            type: String,
            require: true,
            default: ""
        },
        index: {
            type: Number,
            require: true,
            default: -1
        },
        emitType: {
            type: String,
            require: true,
            default: ""
        }
    },
    data() {
        return {};
    },
    provide() { },
    inject: [],
    computed: {
        templateShow() {
            if (this.showKey === 'prices') {
                return this.item.editAssistantEnabled
            }
            if (this.showKey === 'space') {
                return this.item.editSpaceEnabled
            }
            return false
        }
    },
    watch: {},
    created() { },
    mounted() { },
    methods: {
        openAssignEdit(){
            this.$emit('openAssignEdit', this.index, this.item, this.emitType)
        },
    },
};
</script>

<style lang="scss" module></style>
